import * as React from 'react'

import type { EditableCustomFieldProps } from './typings'
import { EditableCustomText } from './EditableCustomText'
import { EditableCustomDate } from './EditableCustomDate'
import { EditableCustomNumber } from './EditableCustomNumber'
import { EditableCustomCheckbox } from './EditableCustomCheckbox'
import { EditableCustomMultiSelect } from './EditableCustomMultiSelect'
import { EditableCustomSingleSelect } from './EditableCustomSingleSelect'

export function EditableCustomField(props: EditableCustomFieldProps) {
  switch (props.field.type) {
    case 'Text':
      return <EditableCustomText {...props} />
    case 'Date':
      return <EditableCustomDate {...props} />
    case 'Number':
      return <EditableCustomNumber {...props} />
    case 'Checkbox':
      return <EditableCustomCheckbox {...props} />
    case 'DropdownMultiSelect':
      return <EditableCustomMultiSelect {...props} />
    case 'DropdownSingleSelect':
      return <EditableCustomSingleSelect {...props} />
    default:
      return null
  }
}
